import React, { useEffect } from "react";
import { pgVIPMaxFileSize } from "../mixPanelEvents/mixPanelEvents";
import {
    ModalOverlay,
    ModalBox,
    CloseButton,
    ModalContent,
    ModalTitle,
    ModalTitleBreak,
    ModalTutorialText,
    AspectRatioBox,
    ButtonRow,
    PrimaryLinkButton,
    OutlineCloseButton,
} from "./index.styled";

export interface FileSizeErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    page: 'Chat' | 'Upload';
    type: 'Coach' | 'Member';
}

const FileSizeErrorModal: React.FC<FileSizeErrorModalProps> = ({ isOpen, onClose, page, type }) => {
    const sizeLimit = 250;

    useEffect(() => {
        if (isOpen) {
            pgVIPMaxFileSize({ Page: page, Type: type });
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <ModalOverlay onClick={onClose}>
            <ModalBox onClick={(e: React.MouseEvent) => e.stopPropagation()}>
                <CloseButton onClick={onClose} aria-label="Close">&#x2715;</CloseButton>
                <ModalContent>
                    <ModalTitle>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            style={{ flexShrink: 0 }}
                        >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M11.354 4.646a.5.5 0 0 0-.707 0l-6 6a.5.5 0 0 0 .707.707l6-6a.5.5 0 0 0 0-.707z"/>
                        </svg>
                        <span>Max file size is <ModalTitleBreak />{sizeLimit} MB</span>
                    </ModalTitle>
                    <ModalTutorialText>
                        Please watch this tutorial on how to compress your video:
                    </ModalTutorialText>
                    <AspectRatioBox>
                        <iframe
                            width="560"
                            height="315"
                            src="https://player.vimeo.com/video/891898335?h=01bacc9a64"
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            title="How to compress your video"
                        />
                    </AspectRatioBox>
                    <ButtonRow>
                        <PrimaryLinkButton
                            href="https://www.performancegolf.com/compress-vip"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Compress Your Video Here
                        </PrimaryLinkButton>
                        <OutlineCloseButton onClick={onClose}>Close</OutlineCloseButton>
                    </ButtonRow>
                </ModalContent>
            </ModalBox>
        </ModalOverlay>
    );
};

export default FileSizeErrorModal;
